import React, { useEffect, useState } from "react";
import {
  Table,
  TableContainer,
  Typography,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Button,
  Pagination,
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
} from "@mui/material";
import "../../Styles/Pages/admin_fieldofficers.css";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import CloseIcon from "@mui/icons-material/Close";
import { instance } from "../../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Admin_topbar from "../../Layouts/Admin_layout/Admin_topbar";
import { EditNote } from "@mui/icons-material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
  border: "1px solid #79c245",
  marginRight: "10px",
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#79c245",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  fontFamily: "Poppins,sans-serif",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

function Locations() {
  const [locations, setLocations] = useState([]);
  const [name, setName] = useState("");
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [district, setDistrict] = useState("");
  const [state, setState] = useState("");
  const [nameError, setNameError] = useState("");
  const [districtError, setDistrictError] = useState("");
  const [stateError, setStateError] = useState("");
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const locationpage = 10;
  const indexOfLastlocation = currentPage * locationpage;
  const indexOfFirstlocation = indexOfLastlocation - locationpage;
  const currentlocation = Array.isArray(filteredLocations)
    ? filteredLocations.slice(indexOfFirstlocation, indexOfLastlocation)
    : [];
  const [isEditing, setIsEditing] = useState(false);
  const [locationId, setLocationId] = useState(null);

  const handleOpen = () => {
    setOpen(true);
    setIsEditing(false);
  };

  const handleClose = () => {
    setOpen(false);
    setName("");
    setDistrict("");
    setState("");
    setNameError("");
    setDistrictError("");
    setStateError("");
    setIsEditing(false);
    setLocationId(null);
  };

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearch(query);

    if (query === "") {
      setFilteredLocations(locations);
    } else {
      const filtered = locations.filter((location) =>
        Object.values(location).some((value) =>
          value.toString().toLowerCase().includes(query)
        )
      );
      setFilteredLocations(filtered);
    }
    setCurrentPage(1);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const fetchLocations = async () => {
    try {
      const response = await instance.get("/locations");
      setLocations(response.data.data);
      setFilteredLocations(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const validateForm = () => {
    let isValid = true;
    if (!name) {
      setNameError("Mandal is required");
      isValid = false;
    } else {
      setNameError("");
    }
    if (!district) {
      setDistrictError("District is required");
      isValid = false;
    } else {
      setDistrictError("");
    }
    if (!state) {
      setStateError("State is required");
      isValid = false;
    } else {
      setStateError("");
    }
    return isValid;
  };

  const addLocations = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      const response = await instance.post("/location/add", {
        name: name,
        district_name: district,
        state_name: state,
      });
      setLocations([...locations, response.data.data]);
      setName("");
      setDistrict("");
      setState("");
      setOpen(false);
      if (response.status === 200) {
        toast.success(response.data.msg, { toastId: "add-success", autoClose: 5000 });
        fetchLocations();
      }
    } catch (err) {
      toast.error(err.response.data.message, { toastId: "add-error", autoClose: 5000 });
    }
  };

  const updateLocations = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      const response = await instance.post("/location/update", {
        location_id: locationId,
        name: name,
        district_name: district,
        state_name: state
      })
      setLocations([...locations, response.data.data])
      setLocationId(null)
      setName("");
      setDistrict("");
      setState("");
      setOpen(false)


      if (response.status === 200) {
        toast.success(response.data.msg, { toastId: "update-success", autoClose: 5000 });
        fetchLocations();
      }
    } catch (err) {
      toast.error(err.response.data.message, { toastId: "update-error", autoClose: 5000 });
    }
  }

  const handleEditClick = (location) => {
    setOpen(true);
    setIsEditing(true)
    setLocationId(location._id)
    setName(location.name);
    setDistrict(location.district_name);
    setState(location.state_name);
  }

  useEffect(() => {
    fetchLocations();
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();
    if (isEditing) {
      updateLocations();
    } else {
      addLocations();
    }
  }

  const handleChange = (e, type) => {
    let value = e.target.value;

    // Prevent leading spaces
    if (value.startsWith(" ")) return;

    // Replace multiple spaces with a single space
    value = value.replace(/\s{2,}/g, " ");

    // Validate
    if (type === "name") {
      setName(value);
      setNameError(value.trim() === "" ? "Mandal name cannot be empty" : "");
    } else if (type === "district") {
      setDistrict(value);
      setDistrictError(
        value.trim() === "" ? "District name cannot be empty" : ""
      );
    } else if (type === 'state') {
      setState(value);
      setStateError(
        value.trim() === "" ? "State name cannot be empty" : ""
      );
    }
  };

  return (
    <div style={{ margin: "20px 20px 0px 0px" }}>
      <Admin_topbar />
      <div className="officer_section">
        <BootstrapDialog
          className="sales_entry"
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            <Typography sx={{ fontFamily: 'Poppins,sans-serif' }}>{isEditing ? "Edit Location" : "Add Location"}</Typography>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <form onSubmit={submitHandler}>
              <div className="adduser_bg">
                <div className="user_form">
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        id="outlined-basic"
                        label="Mandal *"
                        variant="outlined"
                        name="Mandal"
                        value={name}
                        onChange={(e) => handleChange(e, "name")}
                        error={!!nameError}
                        helperText={nameError}

                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="outlined-basic"
                        label="District *"
                        variant="outlined"
                        name="district"
                        value={district}
                        onChange={(e) => handleChange(e, "district")}
                        error={!!districtError}
                        helperText={districtError}

                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="outlined-basic"
                        label="State *"
                        variant="outlined"
                        name="state"
                        value={state}
                        onChange={(e) => handleChange(e, "state")}
                        error={!!stateError}
                        helperText={stateError}

                      />
                    </Grid>
                    <Grid item xs={12}>
                      <div className="cancel_save_user">
                        <Button
                          className="cancel"
                          variant="outlined"
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                        <Button type="submit" className="save_user">
                          {isEditing ? "Update" : "Add"}
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </form>
          </DialogContent>
        </BootstrapDialog>
        <section className="main_box">
          <div className="container-fluid">
            <div className="table_box">
              <TableContainer component={Paper}>
                <div className="table_inbox">
                  <div className="add_user_list">
                    <div className="add_user_content">
                      <div
                        style={{
                          fontFamily: "Poppins,sans-serif",
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                      >
                        Locations
                      </div>
                    </div>
                    <div className="add_user">
                      <div>
                        <Search>
                          <SearchIconWrapper>
                            <SearchIcon />
                          </SearchIconWrapper>
                          <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ "aria-label": "search" }}
                            type="search"
                            value={search}
                            onChange={handleSearch}
                          />
                        </Search>
                      </div>
                      <Button variant="outlined" onClick={handleOpen}>
                        Add Location
                      </Button>
                    </div>
                  </div>
                  <Table
                    className="adduser_table user_table product_table"
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow className="table_head">
                        <TableCell align="center" className="first-child">
                          Sl.No
                        </TableCell>
                        <TableCell align="center" className="second-child">
                          Mandal Name
                        </TableCell>
                        <TableCell align="center" className="third-child">
                          District
                        </TableCell>
                        <TableCell align="center" className="third-child">
                          State
                        </TableCell>
                        <TableCell align="center">
                          Manage
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="table_body">
                      {currentlocation.length > 0 ? (
                        currentlocation.map((location, index) => (
                          <TableRow key={location._id}>
                            <TableCell align="center">
                              {index + 1 + (currentPage - 1) * locationpage}
                            </TableCell>
                            <TableCell align="center">{location.name}</TableCell>
                            <TableCell align="center">
                              {location.district_name}
                            </TableCell>
                            <TableCell align="center">
                              {location.state_name}
                            </TableCell>
                            <TableCell align="center">
                              <EditNote className="view-icon" onClick={() => handleEditClick(location)} />
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={12} align="center">
                            <Typography>No matched items</Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <div className="pagination_table">
                    <Pagination
                      count={Math.ceil(filteredLocations.length / locationpage)}
                      page={currentPage}
                      onChange={(event, page) => paginate(page)}
                      shape="rounded"
                      variant="outlined"
                    />
                  </div>
                </div>
              </TableContainer>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Locations;
